import React from 'react';
import { UsersIcon } from 'lucide-react';
type ScarcityBarProps = {
  spotsLeft?: number;
  total?: number;
};
export function ScarcityBar({
  spotsLeft = 12,
  total = 150
}: ScarcityBarProps) {
  const claimed = total - spotsLeft;
  const percent = Math.round(claimed / total * 100);
  return <div className="w-full rounded-2xl border border-alert-500/30 bg-ink-900/70 p-4" data-id="element-52" data-mp="2q3hf6vop7men">
      <div className="flex items-start justify-between gap-3" data-id="element-53" data-mp="2b705e8w5qfu7">
        <p className="flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.12em] text-white/70" data-id="element-54" data-mp="2b5fbmlho30xe">
          <UsersIcon className="h-3.5 w-3.5 text-alert-500" aria-hidden="true" data-id="element-55" data-mp="2g3gt51zg2s6r" />
          Promotional spots
        </p>
        <p className="text-[11px] font-bold uppercase tracking-[0.12em] text-alert-500" data-id="element-56" data-mp="274vdbelcxr9o">
          {percent}% claimed
        </p>
      </div>

      <div className="mt-3 h-3 w-full overflow-hidden rounded-full bg-white/10" role="progressbar" aria-valuenow={percent} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-57" data-mp="g09lrz36kjc">
        <div className="h-full rounded-full bg-alert-500" style={{
        width: `${percent}%`
      }} data-id="element-58" data-mp="2zljdu4cli7ss" />
      </div>

      <p className="mt-3 text-[13px] font-semibold leading-snug text-white sm:text-sm" data-id="element-59" data-mp="3dbmvei0j5dbw">
        Only <span className="text-alert-500" data-id="element-60" data-mp="38emns2o182io">{spotsLeft} spots left</span> at the $27 promotional
        price.
      </p>
    </div>;
}